import PropTypes from 'prop-types';

export const EducatorInSpaces = PropTypes.shape({
  id: PropTypes.string,
  name: PropTypes.string,
});

export const User = PropTypes.shape({
  id: PropTypes.string,
  externalId: PropTypes.string,
  email: PropTypes.string,
  fullName: PropTypes.string,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  role: PropTypes.string,
  userRoles: PropTypes.arrayOf(PropTypes.string),
  isInstructor: PropTypes.bool,
  educatorInSpaces: PropTypes.arrayOf(EducatorInSpaces),
});
